export const EGarnishmentType = {
  ChildSupport: "child_support",
  FederalTaxLevy: "federal_tax_levy",
  StateTaxLevy: "state_tax_levy",
  Creditor: "creditor",
  StudentLoan: "student_loan",
  Other: "other",
} as const;

export type EGarnishmentType =
  (typeof EGarnishmentType)[keyof typeof EGarnishmentType];
